import { module } from 'stereomodularjs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.standLinks = this.el.querySelectorAll('[data-isStand]');
        this.standLinks.forEach(standLink => {
            standLink.addEventListener('click', this.click.bind(this));
        });

        this.el.querySelectorAll('.js-plan .js-close').forEach(close => {
            close.addEventListener('click', this.removeActive.bind(this));
        });

        this.el.querySelector('input[name="exposant"]').addEventListener('change', this.filterExposant.bind(this));
        this.el.querySelector('input[name="scene"]').addEventListener('change', this.filterScene.bind(this));
    }

    click(e) {
        e.preventDefault();
        const id = e.target.getAttribute('data-stand');
        const divs = this.el.querySelectorAll('.js-plan div[data-stand="'+id+'"]');
        divs.forEach(div => {
            div.classList.remove('is-active', 'is-highlighted');
            div.classList.toggle('is-active');
        });

        const filter = this.el.querySelector('.o-filter__accordion');
        filter.classList.toggle('is-open');

        const floorPlan = this.el.querySelector('.c-floor-plan-dynamique');
        const offset = floorPlan.offsetTop;
        window.scrollTo(0, offset);

        return false;
    }

    filterExposant(e) {
        const value = e.target.checked;
        this.standLinks.forEach(standLink => {
            if (standLink.dataset.scene == '1') return;
            standLink.style.display = value ? 'block' : 'none';
        });
    }

    filterScene(e) {
        const value = e.target.checked;
        this.standLinks.forEach(standLink => {
            if (standLink.dataset.scene == '0') return;
            standLink.style.display = value ? 'block' : 'none';
        });
    }

    removeActive(e) {
        e.preventDefault();
        this.el.querySelectorAll('.js-plan .is-active');
        this.el.querySelectorAll('.js-plan .is-active').forEach(div => {
            div.classList.remove('is-active');
        });
    }

    destroy() {
        this.standLinks.forEach(standLink => {
            standLink.removeEventListener('click', this.click);
        });
        this.el.querySelectorAll('.js-plan .js-close').forEach(close => {
            close.removeEventListener('click', this.removeActive);
        });
        this.el.querySelector('input[name="exposant"]').removeEventListener('change', this.filterExposant);
        this.el.querySelector('input[name="scene"]').removeEventListener('change', this.filterScene);
    }
}